import { appConstants } from "JS/Helpers/Constants";
import { IncomeDisclosure } from "JS/Models/IncomeDisclosure";

const STORAGE_KEY = appConstants.localStorage.incomeDisclosureAccepted;

export const getAcceptedIncomeDisclosureVersion = (
    memberId: string,
): string | null => {
    if (!memberId) return null;
    try {
        const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
        const isOwnVersion =
            saved?.memberId === memberId && typeof saved.version === "string";
        return isOwnVersion ? saved.version : null;
    } catch {
        return null;
    }
};

export const setAcceptedIncomeDisclosureVersion = (
    memberId: string,
    version: IncomeDisclosure["version"],
) =>
    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ memberId, version: String(version) }),
    );

export const isIncomeDisclosureAccepted = (
    memberId: string,
    version: IncomeDisclosure["version"],
) => getAcceptedIncomeDisclosureVersion(memberId) === String(version);
